module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "list-group discussions"
  }, [_vm._v(_vm._s(_vm.comment) + "\n        "), _c('li', {
    staticClass: "discussion clearfix",
    class: {
      'moderated': _vm.comment.moderated == true
    },
    attrs: {
      "id": 'comment' + _vm.comment.id
    }
  }, [(_vm.comment.moderated !== true) ? _c('div', {
    staticClass: "panel clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.comment.user.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("posted "), (_vm.comment.user.firstName) ? _c('span', [_vm._v("by " + _vm._s(_vm.comment.user.firstName) + " " + _vm._s(_vm.comment.user.lastName))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("timeSince")(_vm.comment.createdAt)) + " ago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.text)
    }
  }), _vm._v(" "), (_vm.reply.form === false) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reply.form = !_vm.reply.form
      }
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.role == 'Faculty'),
      expression: "role=='Faculty'"
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteComment($event)
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), (_vm.reply.form === true) ? _c('form', {
    staticClass: "col-xs-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postReply(_vm.comment.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reply.body),
      expression: "reply.body"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.reply.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reply.body = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.comment.moderated == true) ? _c('div', {
    directives: [{
      name: "else",
      rawName: "v-else"
    }],
    staticClass: "panel clearfix instructor-moderated"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [(_vm.role == 'Faculty') ? _c('img', {
    attrs: {
      "src": _vm.comment.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.role == 'Faculty') ? _c('div', {
    staticClass: "author"
  }, [_vm._v("Posted by " + _vm._s(_vm.comment.user.firstName) + " " + _vm._s(_vm.comment.user.lastName) + " " + _vm._s(_vm._f("timeSince")(_vm.comment.createdAt)) + " ago")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [(_vm.role == 'Faculty') ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.text)
    }
  }) : _c('div', [_c('h3', [_vm._v("This post has been moderated")])])])]), _vm._v(" "), (_vm.reply.form === true) ? _c('form', {
    staticClass: "col-xs-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postReply(_vm.comment.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reply.body),
      expression: "reply.body"
    }],
    domProps: {
      "value": (_vm.reply.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reply.body = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)]) : _vm._e()]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.comment.descendents) + "\n            "), _vm._l((_vm.comment.descendents), function(childComment) {
    return (_vm.comment.descendents) ? _c('video-comment', {
      attrs: {
        "post": childComment,
        "recordingId": _vm.recordingId
      }
    }) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26ad8e71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/discussion/VideoComment.vue
// module id = 1974
// module chunks = 2